/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
jQuery(document).ready(function ($) {
/**
 * 
 * PAGINA MODIFICA ANNUNCIO
 * 
 * 
 * 
 */    
function base64ToFile(base64Data, tempfilename, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    var file = new File(byteArrays, tempfilename, { type: contentType });
    return file;
}
    $("#button-modifica-annuncio").click(function () {
        $('#messageUpdateOffer').html('');
        $("#messageUpdateOffer").removeClass('alert-danger');
        $("#messageUpdateOffer").removeClass('alert-success');
        $("#messageUpdateOffer").hide();
        var reg_condizioni = $('#modifica-annuncio-altri-campi-condizioni').val();
        var reg_good_crossing_point = $('#modifica-annuncio-altri-campi-good-crossing-point').val();
        var reg_localizzazione = $('#modifica-annuncio-altri-campi-localizzazione').val();
        var reg_indirizzi_personali = $('#modifica-annuncio-altri-campi-indirizzi-personali').val();
        var reg_titolo = $('#modifica-annuncio-altri-campi-titolo').val();
        var reg_note_consegna = $('#modifica-annuncio-altri-campi-note_consegna').val();
        var reg_idannuncio= $('#modifica-annuncio-altri-campi-idannuncio').val();
        
        var isCerco = $(this).data('tipologia') == 'cerco';
        
        var faiAjax = true;
        if (reg_titolo == '')
        {
            rimuovi_stato('#modifica-annuncio-altri-campi-titolo');
            stato_errore('#modifica-annuncio-altri-campi-titolo', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#modifica-annuncio-altri-campi-titolo');
            stato_success('#modifica-annuncio-altri-campi-titolo');
        }
        
        if (!isCerco && (reg_condizioni == null || reg_condizioni == ''))
        {
            rimuovi_stato('#modifica-annuncio-altri-campi-condizioni');
            stato_errore('#modifica-annuncio-altri-campi-condizioni', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#modifica-annuncio-altri-campi-condizioni');
            stato_success('#modifica-annuncio-altri-campi-condizioni');
        }
        if (!isCerco && ((reg_good_crossing_point == null|| reg_good_crossing_point == '') && (reg_localizzazione == null|| reg_localizzazione == '') && (reg_indirizzi_personali == null|| reg_indirizzi_personali == '')))
        {
            rimuovi_stato('#modifica-annuncio-altri-campi-good-crossing-point');
            stato_errore('#modifica-annuncio-altri-campi-good-crossing-point', 'Almeno un campo richiesto tra Punto ToornaQui, localizzazione e indirizzi personali');
            rimuovi_stato('#modifica-annuncio-altri-campi-localizzazione');
            stato_errore('#modifica-annuncio-altri-campi-localizzazione', 'Almeno un campo richiesto tra Punto ToornaQui, localizzazione e indirizzi personali');
            rimuovi_stato('modifica-annuncio-altri-campi-indirizzi-personali');
            stato_errore('modifica-annuncio-altri-campi-indirizzi-personali', 'Almeno un campo richiesto tra Punto ToornaQui, localizzazione e indirizzi personali');
            faiAjax = false;
        } else
        {
            rimuovi_stato('#modifica-annuncio-altri-campi-good-crossing-point');
            stato_success('#modifica-annuncio-altri-campi-good-crossing-point');
            rimuovi_stato('#modifica-annuncio-altri-campi-localizzazione');
            stato_success('#modifica-annuncio-altri-campi-localizzazione');
            rimuovi_stato('#modifica-annuncio-altri-campi-indirizzi-personali');
            stato_success('#modifica-annuncio-altri-campi-indirizzi-personali');
        }
        if (faiAjax)
        {
            themeSpinner('show');
            form = new FormData();
            // carico ilform tramit formdata per upload del file
            form.append('condizioni', reg_condizioni);
            form.append('good_crossing_point', reg_good_crossing_point);
            form.append('localizzazione', reg_localizzazione);
            form.append('indirizzi_personali', reg_indirizzi_personali);
            form.append('titolo', reg_titolo);
            form.append('id_annuncio', reg_idannuncio);
            form.append('note_consegna', reg_note_consegna);
            form.append('action', 'modifica_annuncio_action'); 
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                data: form,
                        contentType: false,
                        cache: false,
                        processData: false,
                        dataType: "html",
                url: ajax_url,                
                success: function (resp) {
                    if (resp === '1')
                    {
                        $("#messageUpdateOffer").html('Annuncio Modificato con successo');
                        $("#messageUpdateOffer").addClass('alert-success');
                        $("#messageUpdateOffer").show();
                    }
                    else
                    {
                        $("#messageUpdateOffer").html(resp);
                        $("#messageUpdateOffer").addClass('alert-danger');
                        $("#messageUpdateOffer").show();
                    }
                    themeSpinner('hide');
                    
                    
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageUpdateOffer").html('Problemi nella modifica dell\' annuncio');
                    $("#messageUpdateOffer").addClass('alert-danger');
                    $("#messageUpdateOffer").show();
                }

            });
            
        }
    });
    
    
    
    
    //modifica immagini
    $("#button-modifica-immagini-annuncio").click(function () {
        
        var reg_idannuncio= $('#modifica-annuncio-altri-campi-idannuncio').val();
        var reg_foto_1=$('#modifica-immagini-annuncio-foto-1')[0].files[0];
        var reg_foto_2=$('#modifica-immagini-annuncio-foto-2')[0].files[0];
        var reg_foto_3=$('#modifica-immagini-annuncio-foto-3')[0].files[0];
        
        var reg_canc_foto_1= $('#rimuovi_foto_1').val();
        var reg_canc_foto_2= $('#rimuovi_foto_2').val();
        var reg_canc_foto_3= $('#rimuovi_foto_3').val();

        var faiAjax = true;
        var msgtmp = '';
        
        
         if (typeof(reg_foto_1) !== 'undefined' && reg_foto_1 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_1);
            if(tmp)
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_success('#inserimento-annuncio-altri-campi-foto');
            }
            else
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                msgtmp='Attenzione il file 1 deve essere in formato jpeg o png  e non superiore a 8MB';
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp);
            }
        }
        
         if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_2);
            if(tmp)
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_success('#inserimento-annuncio-altri-campi-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp+='<br>Attenzione il file 2 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp);
            }
        }
        
         if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_3);
            if(tmp)
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_success('#inserimento-annuncio-altri-campi-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp+='<br>Attenzione il file 3 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp );
            }
        }
        
        if (faiAjax)
        {
            themeSpinner('show');
            form = new FormData();
            // carico il form tramite formdata per upload del file
            dataURL1=$('#modifica-immagini-annuncio-immaginecompressa-1').attr('src');
            var file1=base64ToFile(dataURL1.split(',')[1], reg_foto_1.name, 'image/jpeg');
            var file2=null;
            var file3 =null;
            if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
            {
                dataURL2=$('#modifica-immagini-annuncio-immaginecompressa-2').attr('src');
                file2=base64ToFile(dataURL2.split(',')[1], reg_foto_2.name, 'image/jpeg');
            }
            if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
            {
                dataURL3=$('#modifica-immagini-annuncio-immaginecompressa-3').attr('src');
                file3=base64ToFile(dataURL3.split(',')[1], reg_foto_3.name, 'image/jpeg');
            }
            form.append('foto_1', file1);
            form.append('foto_2', file2);
            form.append('foto_3', file3);
            form.append('canc_foto_1', reg_canc_foto_1);
            form.append('canc_foto_2', reg_canc_foto_2);
            form.append('canc_foto_3', reg_canc_foto_3);
            form.append('id_annuncio', reg_idannuncio);
            
            form.append('action', 'modifica_immagini_annuncio_action'); 
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                data: form,
                        mimeType: 'multipart/form-data',
                        contentType: false,
                        cache: false,
                        processData: false,
                        dataType: "html",
                url: ajax_url,                
                success: function (resp) {
                    if (resp === '1')
                    {
                        $("#messageUpdateOffer").html('Immagini modificate con successo');
                        $("#messageUpdateOffer").addClass('alert-success');
                        $("#messageUpdateOffer").show();
                    }
                    else
                    {
                        $("#messageUpdateOffer").html(resp);
                        $("#messageUpdateOffer").addClass('alert-danger');
                        $("#messageUpdateOffer").show();
                    }
                    themeSpinner('hide');
                    
                    
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageUpdateOffer").html('Problemi nella modifica delle immagini');
                    $("#messageUpdateOffer").addClass('alert-danger');
                    $("#messageUpdateOffer").show();
                }

            });
            
        }
        
        
        
    });
    
    
});


function memoEliminaImg(elemJs, inputId, divId, number){
    $('#modifica-immagini-annuncio-immaginecompressa-'+number).attr('src', '');
    $('#modifica-immagini-annuncio-immaginecompressa-'+number).attr('src', '');
    $('#modifica-immagini-annuncio-immagineoriginale-'+number).attr('src', '');
    $('#modifica-immagini-annuncio-immagineoriginale-'+number).attr('src', '');
    $elem = jQuery(elemJs);
    $input = jQuery("#"+inputId);
    $div = jQuery("#"+divId);
    
    $input.val(1);
    $elem.hide();
    $div.hide();
}